import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import './PayalSection.css';

const PayalSection = () => {
  const { products, lang } = useContext(AppContext);
  const isMr = lang === 'mr';
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();

  // Filter products for Payal / Anklets dynamically from AppContext
  const payalProducts = (products || []).filter(p =>
    p.category?.toLowerCase().includes('payal') ||
    p.category?.toLowerCase().includes('anklet') ||
    p.category?.toLowerCase().includes('painjan')
  );

  const displayItems = payalProducts.length > 0 ? payalProducts : (products || []).slice(0, 8);

  return (
    <section className="payal-section" id="payal">
      <div className="section-header reveal">
        <h2 className="section-title">
          <span className="title-italic">{isMr ? '९२५ चांदीचे दागिने' : '925 Silver Jewellery'}</span> {isMr ? 'कलेक्शन' : 'Collection'}
        </h2>
        <div className="title-ornament">
          <span /><span className="ornament-diamond">◆</span><span />
        </div>
      </div>

      <div className="payal-grid">
        {displayItems.map((item, i) => {
          const name = isMr ? (item.nameMr || item.name) : item.name;
          const type = item.category || (isMr ? 'पैंजण' : 'Anklet');
          const badge = item.badge || (item.rating >= 4.8 ? (isMr ? 'बेस्टसेलर' : 'Bestseller') : null);

          return (
            <div
              key={item.id || i}
              className={`payal-card reveal delay-${(i % 4) + 1}`}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              {badge && <div className="card-badge">{badge}</div>}
              <div className="card-img-wrap">
                <img
                  src={item.image}
                  alt={name}
                  onError={(e) => {
                    e.currentTarget.src = '/images/painjan.jpg';
                  }}
                />
                <div className={`card-overlay ${hovered === i ? 'visible' : ''}`}>
                  <div className="overlay-content">
                    <span className="overlay-tag">{type}</span>
                    <button
                      className="overlay-btn"
                      onClick={() => navigate(`/contact?subject=${encodeURIComponent('Wholesale Enquiry - ' + item.name)}`)}
                    >
                      {isMr ? 'होलसेल चौकशी' : 'Wholesale Enquiry'}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-info">
                <span className="card-type">{type}</span>
                <h4 className="card-name">{name}</h4>
                <div className="card-line" />
              </div>
            </div>
          );
        })}
      </div>

      <div className="section-cta reveal">
        <button className="btn-outline-dark" onClick={() => navigate('/products')}>
          {isMr ? 'संपूर्ण कॅटलॉग पहा' : 'Explore Full Catalogue'}
        </button>
      </div>
    </section>
  );
};

export default PayalSection;
